import BaseEntity from '../BaseEntity.model';
import { Progress } from './Progress.model';

export default interface IMetric extends BaseEntity {
    Name: string;
    Progress: Progress[];
    CreatedTime: string;
    CreatedAt: string;
    UpdatedAt: string;
}

export class Metric implements IMetric {
    Id: string | null;
    Name: string;
    Progress: Progress[];
    CreatedTime: string;
    CreatedAt: string;
    UpdatedAt: string;

    IsSelected: boolean;
    IsOpenProgress: boolean;
    NewProgressNote: string;

    constructor() {
        this.Id = null;
        this.Name = '';
        this.CreatedTime = '';
        this.CreatedAt = '';
        this.UpdatedAt = '';

        this.IsSelected = false;
        this.IsOpenProgress = false;
        this.NewProgressNote = '';
    }
}
